import React from 'react';
import Typography from '@src/new-components/Typography';
import { IconButton } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { Close } from '@mui/icons-material';
import { StyledDialogTitle } from '../index.style';

const Title = ({ title, handleCloseDialog }) => (
  <StyledDialogTitle>
    <Typography
      component="p"
      variant="body-20-bold"
      color={COLOR.descriptionGray}
    >
      {title}
    </Typography>
    <IconButton className="close-icon" onClick={handleCloseDialog}>
      <Close />
    </IconButton>
  </StyledDialogTitle>
);

export default Title;
